var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isActivatedOnboardingEmailV2 && !_vm.isAuthDomain
    ? _c(
        "div",
        { staticClass: "email-listing-domain-auth-banner" },
        [
          _c("div", { staticClass: "alert alert-warning" }, [
            _c("p", { staticClass: "flex-level jc-space" }, [
              _c("span", [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$l10n.__(
                        "Attention votre domaine n’est pas encore authentifié. La délivrabilité de vos emails peut en être affectée."
                      )
                    ) +
                    "\n                "
                ),
                _c(
                  "span",
                  {
                    staticClass: "link",
                    on: {
                      click: function($event) {
                        return _vm.checkDomainAuth()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$l10n.__(
                            "Vérifier l’authentification de mon domaine"
                          )
                        )
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "link",
                  attrs: {
                    href:
                      "https://help.sellsy.com/hc/receiving-and-sending-emails-with-sellsy/set-up-your-domain-for-better-deliverability?searched=true",
                    target: "_blank"
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$l10n.__("Besoin d’aide ? Accéder à notre tutoriel")
                      )
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "CompassDialog",
            {
              staticClass: "email-listing-domain-auth-dialog__failed",
              attrs: {
                visible: _vm.infoModal.active,
                size: "small",
                title: _vm.infoModal.title
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.infoModal, "active", $event)
                },
                "before-close": function($event) {
                  return _vm.beforeClose(_vm.infoModal.isAuth)
                }
              }
            },
            [
              _c("template", { slot: "default" }, [
                _c("div", { staticClass: "dialog__default acenter" }, [
                  _c("i", {
                    staticClass: "modal-icon",
                    class: _vm.infoModal.icon
                  }),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "typographies-paragraph-medium-regular" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.infoModal.description) +
                          "\n                "
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("template", { slot: "footer" }, [
                _c(
                  "div",
                  { staticClass: "dialog__footer" },
                  [
                    _c("CompassButton", {
                      attrs: {
                        label: _vm.infoModal.primaryBtn.label,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          _vm.beforeClose(_vm.infoModal.isAuth)(
                            _vm.infoModal.primaryBtn.action
                          )
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            2
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }